import React from 'react';
import SectionHeader from '@/components/SectionHeader';
import { SimpleReveal } from '@/hooks/useSimpleAnimation';
import { useHomeData } from '../../hooks/useHomeData';

export const HomeCapabilitiesSection = () => {
  const { capabilities } = useHomeData();

  return (
    <section className="section-spacing px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto bg-white">
      <SectionHeader title="Development" subtitle="Our Development Model" className="mb-6" />
      <p className="text-section-description max-w-4xl mx-auto text-center mb-12">
        From concept to commercial scale, our integrated approach covers every stage of lipid-based drug delivery development.
      </p>
      
      <ul className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
        {capabilities.map((item, index) => (
          <SimpleReveal key={index} delay={index * 50}>
            <li className="h-full list-none">
              <div className="group relative h-full rounded-2xl border border-neutral-200 p-2 md:p-3 transition-all duration-300 hover:border-primary/30 hover:shadow-lg hover:shadow-primary/5">
                <div className="relative flex h-full flex-col overflow-hidden rounded-xl border border-neutral-100 bg-background p-5 md:p-6 shadow-sm transition-all duration-300 group-hover:border-primary/20">
                  <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-[hsl(var(--color-1))] to-[hsl(var(--color-3))] flex items-center justify-center mb-3 md:mb-4 transition-transform duration-300 group-hover:scale-105">
                    {React.cloneElement(item.icon as React.ReactElement, { className: 'h-8 w-8 text-white' })}
                  </div>
                  <h3 className="flex items-start pt-0.5 text-xl leading-[1.375rem] font-semibold font-sans tracking-[-0.04em] md:text-2xl md:leading-[1.875rem] text-balance text-foreground mb-2 md:mb-3">
                    {item.title}
                  </h3>
                  <p className="text-body">
                    {item.description}
                  </p>
                </div>
              </div>
            </li>
          </SimpleReveal>
        ))}
      </ul>
    </section>
  );
};
